import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Spirit } from '../../../../core/models/spirit.model';
import { PriceComponent } from '../../../../shared/components/price/price.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SpiritImagePipe } from '../../../../core/pipes/spiritImage';
import { LocalService } from '../../../../core/services/local.service';
import { SpiritTranslationPipe } from '../../../../core/pipes/spiritTranslation';
import { CatalogTranslationPipe } from '../../../../core/pipes/catalogTranslation';

const pipes = [
  SpiritImagePipe,
  SpiritTranslationPipe,
  CatalogTranslationPipe
]

@Component({
  selector: 'app-grid-item',
  standalone: true,
  imports: [PriceComponent, ...pipes],
  templateUrl: './grid-item.component.html',
  styleUrl: './grid-item.component.scss'
})
export class GridItemComponent {

  @Input() spirit!: Spirit;
  @Input() menu: any;
  @Input() lockerUser: any = null;
  @Output() goToDetail = new EventEmitter<Spirit>();

  private local = inject(LocalService);

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  navigate(spirit: Spirit) {
    this.goToDetail.emit(spirit);
  }

  favorite(spirit: Spirit) {
    spirit.fav = !spirit.fav;
    this.local.manageFavorites(spirit);
  }

}
